export default {
    h: ':hover',
    f: ':focus',
    c: ':checked',
    a: ':active',
    first: '>*:first-child',
    ft: '>*:first-child',
    last: '>*:last-child',
    lt: '>*:last-child',
    odd: '>*:nth-child(odd)',
    od: '>*:nth-child(odd)',
    even: '>*:nth-child(even)',
    ev: '>*:nth-child(even)',
    all: ' *',
    '*': ' *',
    every: '>*',
    '>': '>*',
    between: '>*+*',
    bt: '>*+*',
    after: '::after',
    aft: '::after',
    before: '::before',
    bef: '::before',
    dark: (selector) => `.dark ${selector}`,
};
